var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.5 10.7H42.9c-.7-3-2.6-4.6-5.1-5-2.2-4.3-6-5.2-10.5-5.2-1.8 0-7.9.3-11.4 4.8-2.6 3.3-3.3 8-2 14.1-1.5.8-1.6 2.5-1.1 4.1.3 1.5 1.3 6.1 3.8 6.6.3 1.1.9 3.1 2.2 5.1v5L6.2 45.1a8.9 8.9 0 0 0-5.7 8.3v10.1c0 .6.4 1 1 1h53c.6 0 1-.4 1-1v-6h6c1.7 0 3-1.3 3-3V13.7c0-1.7-1.4-3-3-3zM17.9 28.3c-1.1-.7-1.1 1.7-3.1-5.3-.6-2.1.5-1.9.4-1.9.6 0 1.1-.6 1-1.2-1.5-5.9-1-10.4 1.3-13.3 2.4-3 6.9-4.3 10.4-4.1h.1c6.3-.3 8.2 4.3 8.2 4.4.5 1.3 2.2-.1 3.9 2.2 1 1.4 1.8 4.4-.2 10.6-.1.3 0 .6.1.9.6.8 1.9-.2 1.2 2.3 0 .1-1.1 5.2-2.4 5.2-.1 0-.4-.1-.8.1-.2.1-.4.4-.4.7-.1.4-1.9 9.7-9.7 10-7.8-.3-9.6-9.6-9.7-10 .1-.2-.1-.4-.3-.6zm14.2 34.2H24l2.9-8.5c.3-.9-.5-1.1-2.5-3.9l3.7-1 3.6 1c-3.3 5.4-3.7-.1.4 12.4zM19.4 42.1l6.5 5.5-6.2 1.7-2.6-6.3zm10.7 5.5 6.4-5.6 2.2.9-2.7 6.4zm5.2-9.8v2.7L28 46.8l-7.3-6.1v-2.9c4.1 4.1 10.2 4.4 14.6 0zM2.5 53.4c0-2.8 1.8-5.4 4.4-6.4l8.3-3.2 3 7.1c.2.4.5.6.9.6h.3l2.9-.8 2.5 3.2-3 8.6H2.5zm51 9.1H34.2l-3-8.6 2.5-3.2 2.6.7h.3c.4 0 .8-.2.9-.6l3-7.2 8.5 3.3c2.6 1 4.4 3.6 4.4 6.4v9.2zm9-8c0 .6-.4 1-1 1h-6v-2.2c0-3.6-2.3-7-5.7-8.3l-12.5-4.8v-5c1.2-2 1.9-4 2.2-5.1 2.4-.5 3.5-5.1 3.8-6.6.5-1.6.4-3.2-1-4.1.8-2.6 1.1-4.9 1.1-6.8h18.3c.6 0 1 .4 1 1v40.9z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 17.3h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zM58.5 25.3h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zM58.5 33.3h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zM49.5 17.3h-2c-1.3 0-1.3 2 0 2h2c.6 0 1-.4 1-1s-.4-1-1-1zM49.5 25.3c-.9.1-3-.5-3 1 0 .6.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1zM49.5 33.3h-2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1zM58.5 41.2h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSummary);
export default __webpack_public_path__ + "static/media/Account-Summary.4f53c9c1dc4a063689429e7142ee577c.svg";
export { ForwardRef as ReactComponent };